var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 24.4744C15.4838 24.8106 14.6388 25 13.75 25C12.8612 25 12.0162 24.8106 11.25 24.4744V25.3987L13.75 28.3987L16.25 25.3987V24.4744Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8389 30.5294L13.5114 31.875H13.9889L14.6614 30.5294L13.7501 30.0737L12.8389 30.5294Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99194 26.25L10.3651 30.3688L12.7644 29.1687L10.3319 26.25H8.99194Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5081 26.25H17.1681L14.7356 29.1687L17.135 30.3688L18.5081 26.25Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.75C20.6894 18.75 21.25 18.1894 21.25 17.5C21.25 16.8106 20.6894 16.25 20 16.25V18.75Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 14.375H11.875C12.8531 14.375 13.7881 13.9075 14.375 13.125L15.125 12.1244C15.3606 11.8106 15.8894 11.8106 16.125 12.1244L16.875 13.1244C17.4619 13.9075 18.3969 14.375 19.375 14.375C19.7206 14.375 20 14.6544 20 15C20.2169 15 20.4238 15.0363 20.625 15.0888V13.75C20.625 9.95937 17.5406 6.875 13.75 6.875C9.95937 6.875 6.875 9.95937 6.875 13.75V15.0888C7.07625 15.0363 7.28312 15 7.5 15C7.5 14.6544 7.77938 14.375 8.125 14.375Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6249 26.25H19.8249L18.0924 31.4475C18.0355 31.6188 17.9061 31.7575 17.7393 31.8269C17.6624 31.8594 17.5811 31.875 17.4999 31.875C17.4043 31.875 17.308 31.8531 17.2205 31.8094L15.7799 31.0888L15.0305 32.5881L16.1374 38.125H21.8749V34.375H23.1249V38.125H25.6249V31.25C25.6249 28.4931 23.3818 26.25 20.6249 26.25Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.5794C17.615 15.4138 16.5712 14.8025 15.875 13.8744L15.625 13.5413L15.375 13.875C14.5531 14.9706 13.2444 15.625 11.875 15.625H8.75V18.75C8.75 21.5069 10.9931 23.75 13.75 23.75C16.5069 23.75 18.75 21.5069 18.75 18.75V15.5794Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2794 31.8094C10.1919 31.8531 10.0956 31.875 10 31.875C9.91875 31.875 9.8375 31.8594 9.76062 31.8275C9.59312 31.7581 9.46375 31.6194 9.4075 31.4481L7.675 26.25H6.875C4.11813 26.25 1.875 28.4931 1.875 31.25V38.125H4.375V34.375H5.625V38.125H11.3625L12.47 32.5881L11.7206 31.0888L10.2794 31.8094Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6375 33.125L12.6375 38.125H14.8625L13.8625 33.125H13.6375Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.75V16.25C6.81062 16.25 6.25 16.8106 6.25 17.5C6.25 18.1894 6.81062 18.75 7.5 18.75Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 15V6.25H35V15H32.5V10H30V15H27.5V11.875H25V15H23.125V16.25H39.375V15H37.5Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0087 4.375H32.5C32.6662 4.375 32.825 4.30937 32.9419 4.19187L34.375 2.75875V4.375H35.625V1.25C35.625 0.904375 35.3456 0.625 35 0.625H31.875V1.875H33.4912L32.2412 3.125H28.75C28.5837 3.125 28.425 3.19063 28.3081 3.30813L24.5581 7.05813L25.4419 7.94187L29.0087 4.375Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6831 17.6831L20.3662 25H20.625C21.0912 25 21.5437 25.0556 21.9812 25.1525L28.3837 18.75H39.375V17.5H28.125C27.9587 17.5 27.8 17.5656 27.6831 17.6831Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/experience-icon.28bf2e662db38dfa57b24cbc6f4f9bfe.svg";
export { ForwardRef as ReactComponent };